export default __webpack_public_path__ + "static/imgHome-257299dbafb8283c5546702b4f1d9a69.webp";